import { Component } from '@angular/core';

@Component({
  selector: 'app-main-pos',
  templateUrl: './main-pos.component.html',
  styleUrls: ['./main-pos.component.css'],
})
export class MainPosComponent {
  constructor() {}
}
